export default __webpack_public_path__ + "static/media/1164-200.d53a4f16.gif";